import { render, staticRenderFns } from "./RichRadioButton.vue?vue&type=template&id=32a089b0&"
import script from "./RichRadioButton.vue?vue&type=script&lang=js&"
export * from "./RichRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports